import React from 'react'

import { TabsLayout } from '@app/layouts'
import { Header } from '@app/components'

import { RegularMonitoringTab, TotalMonitoringTab } from './Tabs'

import type { TabsLayoutItem } from '@app/layouts/TabsLayout/types'

const tabs: TabsLayoutItem[] = [
  {
    label: 'Регулярный/промо',
    key: 'regularMonitoring',
    content: <RegularMonitoringTab />
  },

  {
    label: 'Сплошной',
    key: 'totalMonitoring',
    content: <TotalMonitoringTab />
  }
]

const title = 'Запуск мониторингов'

export const MonitoringLaunchPage: React.FC = () => {
  return (
    <>
      <Header controlProps={ { title } } />

      <TabsLayout tabs={ tabs } />
    </>
  )
}
